<template>
  <section class="bak-color mb-10">
  <div class="container">
    <div class="blocks_sec col-xs-12">
                    <div class="news_blocks ol-xs-12">
                        <div class="news_block ">
                            <!-- <a href="#"><h3>Recent Posts</h3></a> -->
                            <div class="row">
                              <ul class="col-md-6">
                                 <a href="#"><h3>Article</h3></a>


                                  <li class="news-section"  v-for="data in fetchedData" >
                                
                                    <span><router-link :to="'/blog/' + data.attributes.slug"><img v-bind:src="data.attributes.medium_image" alt="data.attributes.title" width="80" height="80"></router-link></span>
                                <div class="news_in col-lg-9 col-md-8 col-sm-9 col-xs-8">
                                  <p class="para-text"><router-link :to="'/blog/' + data.attributes.slug">{{data.attributes.title}}</router-link></p>
                                    <small>{{data.attributes.event_date | convertDate}}<em>{{data.attributes.published_by}}</em></small>
                                </div>
                                <div class="clear"></div>
                                  </li>
                              </ul>

                               <ul class="col-md-6">
                               <a href="#"><h3>News</h3></a>
                                  <li class="news-section"  v-for="data in fetchedNews">
                                    <span><router-link :to="'/blog/' + data.attributes.slug"><img v-bind:src="data.attributes.medium_image" alt="data.attributes.title" width="80" height="80"></router-link></span>
                                <div class="news_in col-lg-9 col-md-8 col-sm-9 col-xs-8">
                                  <p class="para-text"><router-link :to="'/blog/' + data.attributes.slug">{{data.attributes.title}}</router-link></p>
                                    <small>{{data.attributes.event_date | convertDate}}<em>{{data.attributes.published_by}}</em></small>
                                </div>
                                <div class="clear"></div>
                                  </li>
                              </ul>
                           <!--  <li class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-for="data in fetchedData">
                              <span><router-link :to="'/blog/' + data.attributes.slug"><img v-bind:src="data.attributes.medium_image" alt="data.attributes.title" width="80" height="80"></router-link></span>
                                <div class="news_in col-lg-9 col-md-8 col-sm-9 col-xs-8">
                                  <p class="para-text"><router-link :to="'/blog/' + data.attributes.slug">{{data.attributes.title}}</router-link></p>
                                    <small>{{data.attributes.event_date | convertDate}}<em>{{data.attributes.published_by}}</em></small>
                                </div>
                                <div class="clear"></div>
                              </li> -->

                              </div>
                          </div>

                      </div>
                  </div>
    </div><!-- end container -->
    <div class="clear"></div>
  </section>
</template>

<script>
import {HTTP} from '../http-common.js'
import * as moment from 'moment-timezone';

export default {
  name: 'category',
  data () {
    return {
      fetchedData: [],
      fetchedNews:[],
      error: false,
      title : null,
    }
  },

//   computed:{
//   blogs: function() {
//     return this.fetchedData.filter(function(data) {
//       return data.type=='blog';
//     })
//   },

//   news: function(){
//     return this.fetchedData.filter(function(data) {
//       return data.type=='news';
//     })
//   }
// },

  filters: {
  	truncate: function(string, value=150) {
      if(string.length <= value) {
       return string;
       }
       else {
           return string.substring(0, value) + '...';
       }

    },
    escape: function(text){
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    },
    convertDate: function(date){
      return moment(date).format('MMMM Do, YYYY')
    }
  },
  mounted: function(){
      this.fetchData(),
      this.fetchNews()
  },
  methods : {
              fetchData(value='') {
                var url = 'articles'
                HTTP.get(url).then(response => {
                  if(response.status==200){
                    var jsonData =response
                    this.loading = false
                    this.fetchedData = jsonData.data.data

                  }
                })
                .catch(e => {
                  //this.errors.push(e)
                  this.error = true
                })
              },
            fetchNews(value='') {
                var url = 'news'
                HTTP.get(url).then(response => {
                  if(response.status==200){
                    var jsonData =response
                    this.loading = false
                    this.fetchedNews = jsonData.data.data

                  }
                })
                .catch(e => {
                  //this.errors.push(e)
                  this.error = true
                })
              }
  }
}

</script>



// WEBPACK FOOTER //
// Category.vue?50e73002